import React, { useState } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import {
	ugadiImages,
	healthCampImages,
	foodDriveImages,
	taxSeminarImages,
	karthigaImages,
} from "../utils/imageLoader";

Modal.setAppElement("#root");

const images = ["./assets/images/bat-img/ugadi-tile.jpg"];

export default function BatEvents() {
	const navigate = useNavigate();
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [currentGalleryImage, setCurrentGalleryImage] = useState(images);
	const [isLoading, setIsLoading] = useState(false);

	const openModal = (index) => {
		document.body.style.overflow = "hidden";
		setGalleryImages(index);
		setTimeout(() => setModalIsOpen(true), 0);
	};

	const setGalleryImages = (index) => {
		let selectedImages;

		switch (index) {
			case 0:
				selectedImages = ugadiImages;
				break;
			case 1:
				selectedImages = karthigaImages;
				break;
			case 2:
				selectedImages = foodDriveImages;
				break;
			case 3:
				selectedImages = healthCampImages;
				break;
			case 4:
				selectedImages = taxSeminarImages;
				break;
			default:
				selectedImages = images;
		}

		setCurrentGalleryImage(selectedImages);
		setCurrentImageIndex(0);
	};

	const closeModal = () => {
		document.body.style.overflow = "auto";
		setModalIsOpen(false);
	};

	const nextImage = () => {
		setIsLoading(true);
		const nextIndex = (currentImageIndex + 1) % currentGalleryImage.length;

		const img = new Image();
		img.src = currentGalleryImage[nextIndex];
		img.onload = () => {
			setCurrentImageIndex(nextIndex);
			setIsLoading(false);
		};
	};

	const prevImage = () => {
		setIsLoading(true);
		const prevIndex =
			(currentImageIndex - 1 + currentGalleryImage.length) %
			currentGalleryImage.length;

		const img = new Image();
		img.src = currentGalleryImage[prevIndex];
		img.onload = () => {
			setCurrentImageIndex(prevIndex);
			setIsLoading(false);
		};
	};

	return (
		<div className="bat-main-home">
			<div className="bat-event-bg"></div>
			<h2 className="footer-title color-red-bat-event fw-500">BAT Events</h2>
			<div className="events-container">
				<section className="events-banner">
					<div className="banner-images"></div>
				</section>
				<div className="events-grid bg-flower-img">
					<div className="event-row">
						<div className="event-card">
							<img src="./assets/images/bat-img/ugadi-tile.jpg" alt="Ugadi" />
							<h3 className="mb-20 text-center">Ugadi</h3>
							<p className="mb-30">
								Ugadi is the Telugu and Kannada New Year, celebrated by Brahmins
								with prayers, feasting, and family gatherings. It marks a fresh
								start with rituals like preparing Ugadi Pachadi, a dish
								symbolizing different life experiences.
							</p>
							<button
								className="button login-btn mt-20"
								onClick={() => openModal(0)}
							>
								View More
							</button>
						</div>
						<div className="event-card">
							<img
								src="./assets/images/bat-img/rudra-tile.jpg"
								alt="Karthika Rudrabhishekam"
							/>
							<h3 className="mb-20 text-center">Karthika Rudrabhishekam</h3>
							<p className="mb-30">
								Karthika Rudrabhishekam is a ritual in the Karthika month, where
								Brahmins perform an abhishekam to Lord Shiva, seeking blessings
								for peace and prosperity.
							</p>
							<button
								className="button login-btn mt-20"
								onClick={() => openModal(1)}
							>
								View More
							</button>
						</div>
						<div className="event-card">
							<img
								src="./assets/images/food-drive/F7.jpg"
								alt="BAT Food Drive"
							/>
							<h3 className="mb-20 text-center">BAT Food Drive</h3>
							<p className="mb-30">
								The Food Drive is a community initiative dedicated to supporting
								those in need by providing nutritious meals. Volunteers come
								together to organize, collect, and distribute food to the needed
								communities.
							</p>
							<button
								className="button login-btn mt-20"
								onClick={() => openModal(2)}
							>
								View More
							</button>
						</div>
					</div>
					<div className="event-row">
						<div className="event-card">
							<img
								src="./assets/images/health-camp/IMG-20240803-WA0060.jpg"
								alt="Health Camp"
							/>
							<h3 className="mb-20 text-center">Health Camp</h3>
							<p className="mb-30">
								An health camp is an event where medical professional provides
								free or low-cost health check-ups, treatments and consultations
								to the community, promoting overall well-being and awareness
							</p>
							<button
								className="button login-btn mt-20"
								onClick={() => openModal(3)}
							>
								View More
							</button>
						</div>
						<div className="event-card">
							<img
								src="./assets/images/tax-seminar/tax-2.jpg"
								alt="Tax Seminar"
							/>
							<h3 className="mb-20 text-center">Tax Seminar</h3>
							<p className="mb-30">
								Tax seminar is an event where experts discuss tax planning, laws
								and strategies to help individuals and businesses navigate tag
								regulations and optimize their finances.
							</p>
							<button
								className="button login-btn mt-20"
								onClick={() => openModal(4)}
							>
								View More
							</button>
						</div>
					</div>
				</div>
			</div>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				className="gallery-modal bg-flower-img"
				overlayClassName="gallery-overlay"
			>
				<button className="close-btn" onClick={closeModal}>
					&times;
				</button>
				<div className="gallery-container">
					<button className="nav-btn left-btn" onClick={prevImage}>
						&#8249;
					</button>
					<div className="image-wrapper">
						<img
							src={currentGalleryImage[currentImageIndex]}
							alt="Event"
							className={`modal-image ${isLoading ? "blurred" : ""}`}
						/>
					</div>
					<button className="nav-btn right-btn" onClick={nextImage}>
						&#8250;
					</button>
				</div>
				<div className="carousel-indicators">
					{currentGalleryImage.map((_, index) => (
						<span
							key={index}
							className={`dot ${index === currentImageIndex ? "active" : ""}`}
							onClick={() => setCurrentImageIndex(index)}
						></span>
					))}
				</div>
			</Modal>
		</div>
	);
}
